module.exports = __webpack_public_path__ + "static/media/book-alt.a2f14ac8.svg";